<header id="page-topbar">
    <div class="navbar-header">
        <div class="d-flex">
            <!-- LOGO -->
            <div class="navbar-brand-box">
                <a routerLink="" class="logo logo-dark">
                    <span class="logo-sm">
                        <img src="assets/images/logo.png" alt="" height="22">
                    </span>
                    <span class="logo-lg">
                        <img src="assets/images/logo.png" alt="" height="23">
                    </span>
                </a>

                <a routerLink="" class="logo logo-light">
                    <span class="logo-sm">
                        <img src="assets/images/logo.png" alt="" width="70" style="padding: 0 5px;">
                    </span>
                    <span class="logo-lg">
                        <img src="assets/images/logo.png" alt="" height="33">
                    </span>
                </a>
            </div>

            <button type="button" class="btn btn-sm px-3 font-size-16 vertinav-toggle header-item waves-effect"
                id="vertical-menu-btn" (click)="toggleMobileMenu($event)" style="width: 70px;">
                <i class="fa fa-fw fa-bars"></i>
            </button>

        </div>

        <div class="d-flex">

            <div class="dropdown d-inline-block" ngbDropdown>
                <button type="button" class="btn header-item waves-effect" ngbDropdownToggle id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <img class="rounded-circle header-profile-user" [src]="configService.token.url_img_avatar" alt="Header Avatar" *ngIf="configService.token.url_img_avatar">
                    <span class="d-none d-xl-inline-block ms-1">{{configService.token.name}}</span>
                    <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
                </button>
                <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                    <!-- item-->
                    <h6 class="dropdown-header">WELCOME {{configService.token.name}}</h6>
                    <a class="dropdown-item" [routerLink]="['/admin/details']" [queryParams]="{ id: configService.token.id }"><i
                            class="mdi mdi-account-circle text-muted font-size-16 align-middle me-1"></i> <span
                            class="align-middle" key="t-profile">Profile</span></a>
                    <!-- <a class="dropdown-item" routerLink="/pages/profile"><i
                            class="mdi mdi-message-text-outline text-muted font-size-16 align-middle me-1"></i> <span
                            class="align-middle" key="t-messages">Messages</span></a> -->
                 
                    <div class="dropdown-divider"></div>

                    <!-- <a class="dropdown-item" href="#"><i
                            class="mdi mdi-cog-outline text-muted font-size-16 align-middle me-1"></i> <span
                            class="align-middle" key="t-settings">Settings</span></a> -->
                   
                    <a class="dropdown-item" href="javascript: void(0);" (click)="logout()"><i
                            class="mdi mdi-logout text-muted font-size-16 align-middle me-1"></i> <span
                            class="align-middle" key="t-logout">logout </span></a>
                </div>
            </div>



        </div>
    </div>
</header>